import { useEffect } from 'react';
import Clarity  from '@microsoft/clarity';

const ClarityAnalytics: React.FC = () => {
  useEffect(() => {
    const clarityKey = process.env.REACT_APP_CLARITY_KEY;
    
    if (!clarityKey) {
      console.warn("Clarity Analytics não foi carregado porque REACT_APP_CLARITY_KEY não está definido.");
      return;
    }

    if ((window as any)?.Clarity && (window as any)?.Clarity.v) {
      console.debug('Clarity já está inicializado');
      return;
    }

    try {
        Clarity.init(clarityKey);
      
        Clarity.consent();
      
      console.debug('Microsoft Clarity inicializado com sucesso');
    } catch (error) {
      console.error('Erro ao inicializar o Microsoft Clarity:', error);
    }

    return () => {
    };
  }, []);

  return null;
};

export default ClarityAnalytics;
